module.exports = __webpack_public_path__ + "images/cabecera_mobile.89f7e577.png";